import { Component, OnInit } from '@angular/core';
import {
  ButtonsConfig,
  ButtonsStrategy,
  AdvancedLayout,
  Image,
  KS_DEFAULT_BTN_CLOSE,
  KS_DEFAULT_BTN_FULL_SCREEN,
  PlainGalleryConfig,
  PlainGalleryStrategy,
} from '@ks89/angular-modal-gallery';
import { BlogDataService } from '@shared/service/blog-data.service';
import { ImageModel } from '@shared/models/blog.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-portfolio-gallery',
  templateUrl: './portfolio-gallery.component.html',
  styleUrls: ['./portfolio-gallery.component.scss']
})
export class PortfolioGalleryComponent implements OnInit {
  public customizer: any = 'all';
  categoryImages;
  categories;
  allImages: Image[] = [];
  constructor(
    public blogDataService: BlogDataService,
    private router: Router
  ) {
    this.blogDataService.dataUpdated$.subscribe(blog => {
      console.log(blog);
      this.convertImages(blog.cImages);
      this.customizer = blog.category;
    });
    this.categories = this.blogDataService.galleryCategory;

  }

  buttonsConfigCustom: ButtonsConfig = {
    visible: true,
    strategy: ButtonsStrategy.CUSTOM,
    buttons: [
      KS_DEFAULT_BTN_FULL_SCREEN,
      KS_DEFAULT_BTN_CLOSE
    ]
  };

  customPlainGalleryRowDescConfig: PlainGalleryConfig = {
    strategy: PlainGalleryStrategy.CUSTOM,
    layout: new AdvancedLayout(-1, true)
  };

  openImageModalRowDescription(image: Image) {
    const index: number = this.getCurrentIndexCustomLayout(image, this.allImages);
    this.customPlainGalleryRowDescConfig = Object.assign({}, this.customPlainGalleryRowDescConfig, { layout: new AdvancedLayout(index, true) });
  }

  private getCurrentIndexCustomLayout(image: Image, images: Image[]): number {
    return image ? images.indexOf(image) : -1;
  }


  setSelectedCategory(category: string) {
    this.blogDataService.setSelectedCategory(category);
  }

  ngOnInit() {
    this.convertImages(this.blogDataService.selectedCategoryData.cImages);
    this.customizer = this.blogDataService.selectedCategoryData.category;
  }

  convertImages(images: ImageModel[]) {
    this.allImages = [];
    images.forEach((img, i) => {
      this.allImages.push(new Image(i, { img: img.url, description: img.description }));
    });
  }

}
